import { useState } from 'react';
import { Typography } from 'seagull/components/Typography';
import { IntroVideoType } from "../../../../models/intro-video";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import IntroVideoModalContent from "../../../../components/AgreementStudio/IntroVideo/IntroVideoModal/IntroVideoModalContent";
import { useForm } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
const IntroductoryVideoModalContent = _ref => {
  let {
    draft,
    setDraft
  } = _ref;
  const videoLink = draft.introVideoLink();
  const form = useForm({
    mode: 'all',
    defaultValues: {
      videoLink: videoLink || ''
    }
  });
  const [videoPlayableStatus, setVideoPlayableStatus] = useState();
  return /*#__PURE__*/_jsx(IntroVideoModalContent, {
    form: form,
    setInputVideoName: inputVideoName => setDraft(draft.setIntroVideo(inputVideoName ? {
      type: IntroVideoType.VideoLink,
      videoLink: {
        url: form.getValues('videoLink')
      }
    } : {
      type: IntroVideoType.None
    })),
    setVideoPlayableStatus: setVideoPlayableStatus,
    videoPlayableStatus: videoPlayableStatus
  });
};
export default function IntroductoryVideoCell(_ref2) {
  let {
    draft,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref2;
  const videoUrl = draft.introVideoLink();
  const onClick = () => onOpenModal({
    submitOnNotDirty: true,
    shouldSubmit: async draft => draft.introVideoLink() !== videoUrl,
    renderContent: _ref3 => {
      let {
        draft,
        setDraft
      } = _ref3;
      return {
        title: 'Introductory video',
        testid: 'edit-introductory-video-modal',
        content: /*#__PURE__*/_jsx(IntroductoryVideoModalContent, {
          draft: draft,
          setDraft: setDraft
        }),
        onSubmit: defaultBehavior => {
          defaultBehavior();
        }
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-introductory-video-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      "data-testid": "introductory-video-".concat(index),
      skin: videoUrl ? 'standard' : 'secondary',
      children: videoUrl || 'Not set'
    })
  });
}